import { user } from '@/mocks/user';

export const fetchUser = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(user);
        }, 10); // 模擬0.01秒的延遲
    });
};